<template>
  <div class="user-page">
    <div class="base-info">
      <div class="base-info-inner">
        <div class="user-header">
          <img
            v-if="userInfo.imgUrl"
            :src="imgSiteUrl + userInfo.imgUrl"
            alt=""
          />
          <img v-else src="~@/assets/img/head1.png" alt="" />
        </div>
        <div class="username">
          {{ userInfo.userName }}
        </div>
        &nbsp;&nbsp;
        <!-- 名字后面添加认证状态图标 -->
        <!-- <div class="attestation" @click="goAttestation">
          <bankOutlined style="color: #e75934" /><span>已认证</span>
        </div> -->
        <div class="intro">
          {{ userInfo.presonalProfile }}
        </div>
        <div
          class="dept"
          v-if="
            userInfo.userPositions &&
            userInfo.userPositions[0] &&
            userInfo.userPositions[0].group_name
          "
        >
          <span class="icon-org"></span>&nbsp;
          {{ userInfo.userPositions[0].group_name
          }}<a-divider type="vertical" />{{
            userInfo.userPositions[0].position
          }}
        </div>
        <div class="edu" v-if="userInfo.school||userInfo.major||userInfo.education">
          <span class="icon-edu"></span>&nbsp;
          <span v-if="userInfo.school">{{ userInfo.school
          }}<a-divider type="vertical" /></span>
          <span v-if="userInfo.major">{{ userInfo.major
          }}<a-divider type="vertical" /></span>
          <span v-if="userInfo.education">{{ userInfo.education }}</span>
        </div>

        <div class="interest" v-show="switchVisible" v-if="userInfo.userTopic&&userInfo.userTopic.length>0">
          <span class="icon-interest"></span>&nbsp;
          <span v-for="(item,key) in userInfo.userTopic" :key="item.topicId"><a-divider type="vertical" v-if="key>0" />{{item.topicName}} </span>
        </div>
        
        <div class="count" v-show="switchVisible" v-if="userInfo.userExt">
          <span>{{ userInfo.userExt.fans }}</span> 粉丝
          <a-divider type="vertical" />
          <span>{{ userInfo.userExt.follow_u_qua }}</span> 关注
        </div>
        <div class="switch" @click="switchVisible=!switchVisible">
          <div v-if="!switchVisible"><down-outlined />查看详情资料</div>
          <div v-else><up-outlined />收起详情资料</div>
        </div>
        <div class="clear"></div>
        <div class="btns">
          <a-button
            type="primary"
            v-if="userId === currentUserId"
            @click="editInfo"
            style="color: #e75934; background: #fff"
            >编辑个人资料</a-button
          >
          <a-button
            type="primary"
            v-else
            :ghost="followstate"
            @click="changeFollowState"
            >{{ followstate ? "已关注" : "关注" }}</a-button
          >
        </div>
      </div>
    </div>
    <div class="main">
      <div class="side-nav">
        <ul>
          <li>
            <router-link
              :to="{
                path: '/user/articles',
                query: { id: userId },
              }"
              ><span>文章</span></router-link
            >
          </li>
          <li>
            <router-link :to="{ path: '/user/thesis', query: { id: userId } }"
              ><span>论文集</span></router-link
            >
          </li>
          <li>
            <router-link :to="{ path: '/user/praise', query: { id: userId } }"
              ><span>点赞</span></router-link
            >
          </li>
          <li>
            <router-link
              :to="{ path: '/user/collection', query: { id: userId } }"
              ><span>收藏</span></router-link
            >
          </li>
          <li>
            <router-link :to="{ path: '/user/focus', query: { id: userId } }"
              ><span>关注</span></router-link
            >
          </li>
        </ul>
        <div class="search">
          <a-input-search
            v-model:value="keyword"
            @search="onSearch"
            placeholder="请输入搜索内容"
          >
          </a-input-search>
        </div>
      </div>
      <div class="user-router">
        <router-view />
      </div>
    </div>
    <div class="right">
      <div class="side-block">
        <div class="block-title">写文章</div>
        <div class="title-line"></div>
        <div class="side-img">
          <img src="@/assets/img/user-edit.png" alt="" />
        </div>
        <div class="side-btn">
          <a-button type="primary" @click="showPubWin" style="background: #fff; color: #e75934"><plus-outlined style="fontSize:16px"/>创建文章</a-button>
        </div>
      </div>
    </div>
    <div class="side-banner">
      <img src="@/assets/img/user-banner.png" alt="" />
    </div>

    <pub-article-win :visible="visible" @close="closePubWin" />
  </div>
</template>

<script>
import { computed, defineComponent, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import config from "../../until/configs";
import Http from "../../until/http";
import {  PlusOutlined,UpOutlined,DownOutlined } from "@ant-design/icons-vue";
import { getCookie, confirmLogin, getLocalItem } from "../../until/tools";
import PubArticleWin from "../../components/PubArticleWin.vue";
export default defineComponent({
  components: {  PlusOutlined,PubArticleWin,UpOutlined,DownOutlined },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const imgSiteUrl = ref(config.imgSiteUrl);
    let visible = ref(false);
    let switchVisible = ref(false);
    let keyword = ref("");
    let userId = computed(() => {
      return parseInt(route.query.id);
    });
    const currentPath = computed(()=>{
      return route.path;
    });

    watch(currentPath,()=>{
      keyword.value = '';
    })
    //去认证
    // const goAttestation = () => {
    //   router.push("/attestationAndIdentity");
    // };
    const onSearch = () => {
      router.push({
        path: route.path,
        query: {
          id: userId.value,
          keyword: keyword.value || undefined,
        },
      });
    };
    let currentUserId = computed(() => {
      let userInfo = getLocalItem('userInfo')||{};
      return userInfo.userId;
    });
    let sid = computed(() => {
      return getCookie("z_sid");
    });
    let userInfo = ref({});
    let followstate = ref(false);

    const changeFollowState = () => {
      if (!sid.value) {
        confirmLogin();
        return false;
      }
      let params = {
        resId: userId.value,
        flag: followstate.value ? 1 : 0,
      };
      Http.foucsAuthor(params).then((res) => {
        if (res) {
          if (res.message) {
            followstate.value = params.flag ? false : true;
          }
        }
      });
    };

    const getBaseInfo = () => {
      Http.getPersonalInfo({ userId: userId.value }).then((res) => {
        if (res.userInfo) {
          document.title =
            res.userInfo.userName + "-个人主页-" + config.siteTitle;
          userInfo.value = res.userInfo;
          followstate.value = res.hasFollow;
        }
      });
    };
    watch(userId,(value)=>{
      if(value) {
        getBaseInfo();
      }      
    })
    const editInfo = () => {
      router.push("/editInfo");
    };
    onMounted(() => {
      getBaseInfo();
      keyword.value = route.query.keyword||'';
    });


    const showPubWin = ()=>{
       if (!sid.value) {
      confirmLogin()
      } else {
        visible.value = true;
      }
    }

    const closePubWin = ()=>{
      visible.value = false;
    }

    return {
      // goAttestation,
      onSearch,
      keyword,
      userId,
      currentUserId,
      userInfo,
      imgSiteUrl,
      changeFollowState,
      followstate,
      editInfo,
      visible,
      showPubWin,
      closePubWin,
      switchVisible
    };
  },
});
</script>

<style lang="scss" scoped>
@import "../../scss/user.scss";
.ant-input{
  background-color: #000 !important;
}

</style>

<style lang="scss">
@import "../../scss/user-router.scss";


</style>
<style lang="scss" scoped>
/deep/.ant-tabs-ink-bar {
  width: 0 !important;
}
.ant-input-affix-wrapper {
    /* background: #FCF6F4; */
    border: 1px solid #ccc;
    border-radius: 18px;
    background: #fff;
}
</style>